export default __webpack_public_path__ + "static/12-2fbcab365f10ba6849087a8657b8e326.png";